export default __webpack_public_path__ + "static/media/3.916fee4b.jpg";